export const sharedFoodServiceBenefits = [
  {
    title: 'Convenience Gain',
    description:
      'Makes food wrapping simple and efficient for both hot and cold packaging. It saves time in preparation and serving, improving overall workflow for businesses.',
  },
  {
    title: 'Cost Saving',
    description:
      'Helps reduce packaging expenses with minimal waste and efficient material usage. Ideal for bulk operations, ensuring better cost control without losing quality.',
  },
  {
    title: 'Customer Experience',
    description:
      'Delivers a clean, hygienic, and non-sticky food presentation that enhances customer satisfaction and keeps food fresh, warm, and neatly packed.',
  },
  {
    title: 'Safety & Quality',
    description:
      'Made from food-grade certified, eco-friendly, and compostable materials that ensure safe usage and meet modern sustainability standards.',
  },
];
